/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateShareExportDataDto
 */
export interface UpdateShareExportDataDto {
    /**
     * Chat export ID
     * @type {string}
     * @memberof UpdateShareExportDataDto
     */
    id: string;
    /**
     * Conversation ID
     * @type {object}
     * @memberof UpdateShareExportDataDto
     */
    conversationId?: object | null;
    /**
     * Whether the export is shared with the provider
     * @type {boolean}
     * @memberof UpdateShareExportDataDto
     */
    isSharedWithProvider: boolean;
}

/**
 * Check if a given object implements the UpdateShareExportDataDto interface.
 */
export function instanceOfUpdateShareExportDataDto(value: object): value is UpdateShareExportDataDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('isSharedWithProvider' in value) || value['isSharedWithProvider'] === undefined) return false;
    return true;
}

export function UpdateShareExportDataDtoFromJSON(json: any): UpdateShareExportDataDto {
    return UpdateShareExportDataDtoFromJSONTyped(json, false);
}

export function UpdateShareExportDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateShareExportDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'conversationId': json['conversationId'] == null ? undefined : json['conversationId'],
        'isSharedWithProvider': json['isSharedWithProvider'],
    };
}

export function UpdateShareExportDataDtoToJSON(json: any): UpdateShareExportDataDto {
    return UpdateShareExportDataDtoToJSONTyped(json, false);
}

export function UpdateShareExportDataDtoToJSONTyped(value?: UpdateShareExportDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'conversationId': value['conversationId'],
        'isSharedWithProvider': value['isSharedWithProvider'],
    };
}

